export default "__VITE_ASSET__Bc$O5K0K__"